import React, { useState } from 'react'
import TradingViewChart from '../../components/charts/RealtimeTrdingChart'
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material'
import { HiBars2 } from 'react-icons/hi2'
import SideDrawer from '../components/SidebarMenu'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { handleCloseCreateOrder } from '../../store/Slices/panelSlice'
import { setGlobalSymbolsData, setTradeModalOpen } from '../../store/Slices/globalSymbolSlice'
import TradeModal from '../../components/modal/trading/TradingModal'

export default function Chart() {
  const bgImage = '/BG.png'
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const editOrderDetail = useSelector(state => state.globalSymbol.editOrderDetail);

  const { globalSymbol, orderPanelOpen } = useSelector(state => state.globalSymbol)
  const handleCloseCreateOrderPanel = () => {
    dispatch(handleCloseCreateOrder());
    dispatch(setTradeModalOpen(false))
  };
  console.log(globalSymbol);

  return (
    <>

      <Box sx={{ height: '100vh', overflow: 'hidden', backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', flexDirection: 'column', }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, }}>
          <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 0.5 }}>
            <HiBars2 onClick={() => setDrawerOpen(true)} style={{ fontSize: 24, color: 'white' }} />
            <Typography color='white' variant='body1' sx={{ fontSize: 18 }}> {t('Chart')}</Typography>
          </Box>
        </Box>
        <Box sx={{ height: 'calc(100vh - 155px)', position: 'relative' }}>
          <TradingViewChart sx={{ position: 'relative' }} />
        </Box>
        <Box sx={{ position: 'absolute', bottom: 57, left: 0, width: '100%', display: 'flex', justifyContent: 'center', zIndex: 10, }}>
          <Button onClick={() => { dispatch(setTradeModalOpen(true)); console.log('open'); }}
            sx={{ backgroundColor: '#0b71f3', color: 'white', px: 2, py: 1, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', }}>
            <Typography fontSize={14} fontWeight={500}>{t('OpenTradePanel')}</Typography>
          </Button>
        </Box>

      </Box>
      <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      {orderPanelOpen && (
        <Dialog open={true} onClose={handleCloseCreateOrderPanel} maxWidth="lg" fullWidth>
          <DialogContent sx={{ p: 0 }}>
            <TradeModal open={true} onClose={handleCloseCreateOrderPanel} showCloseButton={true} />
          </DialogContent>
        </Dialog>)}
    </>
  )
}
